import { Component, OnInit } from '@angular/core';
import { constants } from '../constants';
import { CommonUtilitiesService } from "../common-utilities.service";
import { CreateTicketService } from "./create-ticket.service";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-ticket',
  templateUrl: './create-ticket.component.html',
  styleUrls: ['./create-ticket.component.scss']
})
export class CreateTicketComponent implements OnInit {

  //Listado de lineas
  listLines = [];
  //formulario
  createTicketForm: FormGroup;
  //activacion del botón
  isBtnDisabled = false;
  isLoadingCatBox = false;
  //listado de tipos de asunto
  typeOptions = [];
  //modal
  modalTitle = "";
  modalContent = "";
  isShowModal = false;
  isModalReload = false;
  //validaciones
  numericPattern = "";

  constructor(public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private _router: Router, private createTicketService: CreateTicketService) { }

  ngOnInit() {

    //validaciones de formulario
    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;

    this.createTicketForm = this.formbuilder.group({
      inputType: ['', [Validators.required]],
      inputAddNumber: ['', [Validators.pattern(this.numericPattern)]],
      inputDesc: ['', [Validators.required]],
      inputLines: ['', [Validators.required]],
    });

    //obtiene las lineas de sesion
    let userData = JSON.parse(localStorage.getItem("userData"));
    for (var k in userData.associatedCellPhones) {
      this.listLines.push({ "id": userData.associatedCellPhones[k].id, "linea": userData.associatedCellPhones[k].id });
    }

    //se llenan los tier
    this.getCategoriesList();
  }

 /**
   * Description: Método que obtiene la lista de categorias
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
  */
  getCategoriesList(){
    //obtiene valores permitidos de recargas
    this.isLoadingCatBox = true;
    this.createTicketService.getCategories().subscribe((valData => {
      this.isLoadingCatBox = false;

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      }

      this.typeOptions = valData["obj"];

    }),
      (err) => {
        this.isLoadingCatBox = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });
    }

  /**
   * Description: Método que obtiene la lista de tickets segun la linea seleccionada
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
  */
  createTicket() {
    //validación form
    if (this.createTicketForm.get('inputType').invalid ||
      this.createTicketForm.get('inputAddNumber').invalid ||
      this.createTicketForm.get('inputDesc').invalid) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        return;
    }

    
    if (!this.LANG.isValidPhoneZero(this.createTicketForm.get('inputAddNumber').value)) {
      //si no tiene el prefijo 0 no puede seguir
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
      this.isShowModal = true;
      return false;
    }

    const userData = JSON.parse(localStorage.getItem("userData"));
    let jsonData = {
      "customerAccountId":userData.customerAccountId,
      "summary":this.createTicketForm.get('inputDesc').value,
      "categorizationTier3":this.createTicketForm.get('inputType').value,
      "contactEmail":userData.email,
      "contactCellphoneNumber":this.createTicketForm.get('inputAddNumber').value,
      "phoneLineAffected":this.createTicketForm.get('inputLines').value
    };    

    this.isBtnDisabled = true;
    this.createTicketService.createTicketRequest(jsonData).subscribe((valData => {
      this.isBtnDisabled = false;

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        if (valData['responseCode'] === constants.ERROR_TICKETS_LIMIT_CREATED_NUMBER) {
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = valData['responseMessage'];
          this.isShowModal = true;
          return false;
        }
        
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('CREATE_TICKET_LABEL_ERROR_REQUEST');
        this.isShowModal = true;
        return false;
      }

      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
      this.modalContent = this.LANG.getLangText('CREATE_TICKET_LABEL_SUCCESS_REQUEST') + valData["obj"].ticketId;
      this.isModalReload = true;
      this.isShowModal = true;

    }),
      (err) => {
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }



  /**
  * Description: Método que oculta el modal general
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }

}
